/* eslint-disable i18next/no-literal-string */
import Button from 'react-bootstrap/Button'
import { useParams } from 'react-router-dom'
import FullPageLoginSpinner from 'router/actions/FullPageLoginSpinner'
import { refreshLogin } from 'state/Auth'
import { useDispatchEffect } from 'utils'

export default function LoginRefresh() {
	const { token } = useParams()

	useDispatchEffect(refreshLogin(token))

	return <FullPageLoginSpinner
		text={<>We're preparing stuff inside...<br/>
				Hold on tight,<br/>
				It might be a bumpy ride!</>}
	>
		<Button size="sm" variant="outline-secondary" onClick={() => window.history.back()}>Go back if it didn't go quite right</Button>
	</FullPageLoginSpinner>
}
